import cx from "components/src/utils/cx";
import { SizeType } from "../types/";

export const sizeArray = ["2xs", "xs", "sm", "md", "lg", "xl", "2xl", "3xl", "4xl", "5xl"];

export type SizeStylesReturnType = {
  sizeClasses: string,
  sizeStyle: Record<string, number | string>,
  sizeMap: { width: number | string, height: number | string }
}

export const gapMap = {
  "2xs": "cui-gap-2xs",
  "xs": "cui-gap-xs",
  "sm": "cui-gap-sm",
  "md": "cui-gap-md",
  "lg": "cui-gap-lg",
  "xl": "cui-gap-xl",
  "2xl": "cui-gap-2xl",
  "3xl": "cui-gap-3xl"
}

export const sizeMap = new Map();
sizeMap.set("2xs", {width: 8, height: 8});
sizeMap.set("xs", {width: 10, height: 10});
sizeMap.set("sm", {width: 12, height: 12});
sizeMap.set("md", {width: 16, height: 16});
sizeMap.set("lg", {width: 18, height: 18});
sizeMap.set("xl", {width: 24, height: 24});
sizeMap.set("2xl", {width: 36, height: 36});
sizeMap.set("3xl", {width: 48, height: 48});
sizeMap.set("4xl", {width: 64, height: 64});
sizeMap.set("5xl", {width: 72, height: 72});

export const sizeStyles = (size: SizeType) => {
  
  let _size = size;
  if (size && !isNaN(Number(size))) _size = Number(size)

  const hasSize =
    typeof _size === "string" &&
    sizeArray.includes(_size);

  return {
    sizeClasses: typeof _size !== 'number' ? cx(
      {
        "cui-w-2 cui-h-2": _size === "2xs",
        "cui-w-[10px] cui-h-[10px]": _size === "xs",
        "cui-w-3 cui-h-3": _size === "sm",
        "cui-w-4 cui-h-4": _size === "md" || !hasSize,
        "cui-w-[18px] cui-h-[18px]": _size === "lg",
        "cui-w-6 cui-h-6": _size === "xl",
        "cui-w-9 cui-h-9": _size === "2xl",
        "cui-w-12 cui-h-12": _size === "3xl",
        "cui-w-16 cui-h-16": _size === "4xl",
        "cui-w-18 cui-h-18": _size === "5xl",
        
      },
      "cui-relative cui-inline-block cui-p-0 cui-m-0 [&>svg]:cui-inline-block cui-box-border !cui-not-italic !cui-text-[0px] !cui-leading-[0px]"
    ) : 'cui-inline-block cui-box-border !cui-not-italic !cui-text-[0px] !cui-leading-[0px]',
    sizeStyle:
      !hasSize && typeof _size === "number"
        ? {
            width: `${_size}px`,
            height: `${_size}px`,
          }
        : {},
    sizeMap: sizeMap.get(_size) || { width: _size, height: _size }
  };
};
